var oa = Object.defineProperty, ra = Object.defineProperties;
var sa = Object.getOwnPropertyDescriptors;
var ke = Object.getOwnPropertySymbols;
var ia = Object.prototype.hasOwnProperty, na = Object.prototype.propertyIsEnumerable;
var he = (N, y, g) => y in N ? oa(N, y, { enumerable: !0, configurable: !0, writable: !0, value: g }) : N[y] = g, te = (N, y) => {
  for (var g in y || (y = {}))
    ia.call(y, g) && he(N, g, y[g]);
  if (ke)
    for (var g of ke(y))
      na.call(y, g) && he(N, g, y[g]);
  return N;
}, le = (N, y) => ra(N, sa(y));
var k = (N, y, g) => new Promise((m, E) => {
  var re = (I) => {
    try {
      U(g.next(I));
    } catch (w) {
      E(w);
    }
  }, c = (I) => {
    try {
      U(g.throw(I));
    } catch (w) {
      E(w);
    }
  }, U = (I) => I.done ? m(I.value) : Promise.resolve(I.value).then(re, c);
  U((g = g.apply(N, y)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { checkMenuPermissionSync as ua, reqGetCurrentUser as Ce, getPermissionListSync as da, getDict as Ne } from "@oppein/op-utils";
import ca from "../../node_modules/.pnpm/dayjs@1.10.7/node_modules/dayjs/dayjs.min.js";
import pa from "../../com-components/op-region-select/RegionSelect.vue.js";
import "../../com-components/op-region-select/RegionSelect.vue2.js";
import va from "../brand-category-selector/brandCategorySelector.ce.vue.js";
import { postSelectOrgRightListByCon as ma } from "../../request/internal/org/selectOrgRightListByCon/post.js";
import { postCreateColorProofing as ga } from "../../request/designordercenter/productionOrder/specialApply/createColorProofing/post.js";
import { postCreateRelocateBase as fa } from "../../request/designordercenter/productionOrder/specialApply/createRelocateBase/post.js";
import { postCreateCarrierChange as ya } from "../../request/designordercenter/productionOrder/specialApply/createCarrierChange/post.js";
import { postCreateBigFamilySpecialProcess as wa } from "../../request/designordercenter/productionOrder/specialApply/createBigFamilySpecialProcess/post.js";
import { postCreateBaseSelfPickup as ba } from "../../request/designordercenter/productionOrder/specialApply/createBaseSelfPickup/post.js";
import { postGetPageListByQry as ka } from "../../request/designordercenter/productionOrder/receiver/getPageListByQry/post.js";
import { postGetEsPageListByQry as ha } from "../../request/designordercenter/productionOrder/getEsPageListByQry/post.js";
import { postPage as Ca } from "../../request/apigateway.oppein.com/crmapi/internal/customer/page/post.js";
import { useDialog as Na } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/dialog/src/composables.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import M from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import { toDisplayString as Se } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import _e from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import Sa from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import _a from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tabs/src/Tabs.js";
import ze from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tabs/src/TabPane.js";
import { defineComponent as za, useTemplateRef as Ie, computed as xe, openBlock as C, createElementBlock as T, createElementVNode as p, createVNode as o, withCtx as n, Fragment as O, createBlock as oe, createTextVNode as v, createCommentVNode as _, h as Ia, watch as xa } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as Ra } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as d, unref as l } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import Ba from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import Ta from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import Re from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import f from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import Y from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import pe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/pagination/src/Pagination.js";
import La from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Ma = { class: "tw:mb-4" }, ja = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-2" }, Da = {
  key: 0,
  class: "tw:flex tw:items-center tw:gap-2 tw:mb-4"
}, Ua = { class: "tw:flex tw:gap-2 tw:flex-1" }, Aa = { class: "tw:mb-4" }, Pa = { class: "tw:flex tw:justify-end tw:items-center tw:mt-3 tw:gap-2" }, Ka = { class: "tw:text-gray-500" }, Oa = {
  key: 1,
  class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4"
}, Wa = { class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4" }, $a = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-2" }, Va = {
  key: 1,
  style: { "margin-left": "20px" }
}, Ja = { class: "tw:flex tw:justify-end tw:mt-3" }, Ga = { class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4" }, Fa = { class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4" }, Ya = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-2" }, Ea = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-2" }, Ha = { class: "tw:mb-2 tw:text-sm" }, Qa = { class: "tw:flex tw:justify-end tw:mt-3" }, Za = { class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4" }, Lt = /* @__PURE__ */ za({
  __name: "mallSpApprovalTrigger.ce",
  emits: ["navigate"],
  setup(N, { expose: y, emit: g }) {
    const m = Ra(), E = Na(), re = g;
    let c = null;
    const U = Ie("brandCategorySelectorRef"), I = Ie("triggerContainer"), w = d(!1), h = d(!1), ve = d(!1), W = d(!1), B = d(null), S = d({ code: "" }), me = d([]), Be = xe(() => Me(me.value)), Te = xe(
      () => Be.value.map((a) => ({ label: a.label, value: a.code }))
    ), Le = [
      { permission: "BpmProcessCarrier", code: "bpm_process_carrier" },
      { permission: "BpmProcessDsdyJudge", code: "bpm_process_dsdy_judge" },
      { permission: "BpmProcessJJSpecialProcess", code: "bpm_process_djjspecial_judge" },
      { permission: "BpmProcessRelocatebaseJudge", code: "bpm_process_relocatebase_judge" },
      { permission: "BpmProcessSelfPickupApplication", code: "bpm_process_baseselfpickup_judge" }
    ];
    function Me(a) {
      return a.filter((e) => {
        const s = Le.find((t) => t.code === e.code);
        return s ? ua({ permission: s.permission }) : !0;
      });
    }
    const H = d([]), x = d(null), $ = d([]), je = [
      { type: "selection" },
      { title: "k3扣费账户名称", key: "orgK3Name", width: 180 },
      { title: "k3编码", key: "orgK3Code", width: 180 },
      { title: "经销部", key: "orgBelongClassifySalesName" },
      { title: "线别", key: "orgBelongClassifyName" },
      { title: "商场管理员", key: "orgStoreAdminName" }
    ], De = [
      { type: "selection" },
      { title: "所属事业线", key: "orgBelongMarketClassifyName" },
      { title: "所属经销部", key: "orgBelongDepartmentName" },
      { title: "经销部", key: "orgBelongClassifySalesName" },
      { title: "市场级别", key: "orgMarketRank" },
      { title: "商场管理员", key: "orgStoreAdminName" }
    ];
    function Ue() {
      return k(this, null, function* () {
        const a = yield Ce();
        B.value = a;
        const e = yield ma({ orgNo: a.orgNo });
        H.value = e || [];
      });
    }
    function ge(a) {
      $.value = a.length ? [a[a.length - 1]] : [], x.value = H.value.find((e) => e.orgMarketManageRightId === $.value[0]) || null;
    }
    const V = d(!1), se = d([]), Q = d(null), J = d([]), ie = d([]);
    d(/* @__PURE__ */ new Map());
    const r = d({
      shopList: [],
      isDryWarehouse: 0,
      baseCode: "",
      base: "",
      region: "",
      address: "",
      orgId: "",
      total: 0,
      pageNo: 1,
      pageSize: 100
    }), Ae = [
      { type: "selection", fixed: "left", width: 55 },
      { title: "收货地址ID", key: "id" },
      { title: "收货人", key: "receiver" },
      { title: "收货电话", key: "receiverTel" },
      { title: "收货行政区划", key: "regionName" },
      { title: "收货详细地址", key: "address" },
      {
        title: "品牌品类",
        key: "brandCategoryList",
        render(a) {
          return Ia(
            "button",
            {
              class: "tw:text-blue-500 tw:cursor-pointer tw:bg-transparent tw:border-none tw:underline",
              onClick: () => Pe(a)
            },
            a.brandCategoryList.length ? a.brandCategoryList.map((e) => e.brandName + e.categoryName).join(";") : "请添加品牌品类"
          );
        }
      }
    ];
    function Pe(a) {
      return k(this, null, function* () {
        var s, t;
        const e = yield (t = U.value) == null ? void 0 : t.open({
          orgId: ((s = B.value) == null ? void 0 : s.orgId) || "",
          selectedItems: a.brandCategoryList
        });
        e && Array.isArray(e) && (a.brandCategoryList = e);
      });
    }
    function Ke() {
      return k(this, null, function* () {
        const a = yield Ne("ROOT_MTDS_production_base");
        se.value = (a || []).map((e) => ({
          label: e.label,
          value: e.code
        }));
      });
    }
    function ne(a) {
      var s, t;
      const e = se.value.find((u) => u.value === a);
      Q.value = e ? { code: "", name: e.label, remark: e.value } : null, r.value.baseCode = ((s = Q.value) == null ? void 0 : s.remark) || "", r.value.base = ((t = Q.value) == null ? void 0 : t.name) || "", r.value.region = "", r.value.address = "", J.value = [], r.value.shopList = [], ie.value = [], r.value.total = 0;
    }
    function Z(a, e) {
      return k(this, null, function* () {
        var s;
        if (e) {
          if (!Q.value) {
            m.warning("请选择【基地】");
            return;
          }
          r.value.shopList = [];
        }
        r.value.pageNo = a, h.value = !0;
        try {
          const t = {
            pageNo: a,
            pageSize: r.value.pageSize,
            base: r.value.baseCode,
            region: r.value.region === "1" ? "" : r.value.region,
            address: r.value.address,
            orgId: (s = B.value) == null ? void 0 : s.orgId
          }, u = yield ka(t);
          u && u.records && (J.value = (u.records || []).map((z) => le(te({}, z), {
            keyId: `${z.id}-${z.brand}-${z.category}`,
            brandCategoryList: []
          })), r.value.total = u.total || 0);
        } catch (t) {
          console.error("查询收货地址失败:", t), J.value = [], r.value.total = 0;
        } finally {
          h.value = !1;
        }
      });
    }
    function Oe(a) {
      ie.value = a, r.value.shopList = a.map((e) => J.value.find((s) => s.keyId === e)).filter(Boolean);
    }
    function We(a) {
      r.value.pageSize = a, Z(1);
    }
    function ue() {
      r.value.region = "", r.value.address = "", V.value = !1;
    }
    function $e() {
      return k(this, null, function* () {
        if (!r.value.baseCode) {
          m.warning("请选择基地");
          return;
        }
        if (!r.value.shopList.length) {
          m.warning("请选择收货地址");
          return;
        }
        if (r.value.shopList.some((a) => !a.brandCategoryList.length)) {
          m.warning("需要发起承运商申请的收货地址请选择品牌品类");
          return;
        }
        if (S.value.code === "bpm_process_carrier") {
          const a = r.value.shopList.some((u) => u.category === "category_jinshumenchuang"), e = r.value.shopList.some((u) => u.category !== "category_jinshumenchuang");
          if (a && e) {
            m.warning("金属门窗品类不能与其他品类一起发起");
            return;
          }
          const s = r.value.shopList.some((u) => u.category === "category_jinshumenchuang"), t = r.value.shopList.some((u) => u.category !== "category_jinshumenchuang");
          if (s && t) {
            m.warning("装甲门品类不能与其他品类一起发起");
            return;
          }
        }
        if (r.value.shopList.some((a) => !a.address)) {
          const a = r.value.shopList.filter((e) => !e.address).map((e) => e.shopName);
          E.warning({
            title: "提示",
            content: `所选的【${a.join("、")}】门店无配置默认收货地址，无法发起申请！请确认是否跳转到收货地址管理或重新选择门店发起`,
            positiveText: "跳转收货地址管理",
            negativeText: "取消",
            onPositiveClick: () => {
              re("navigate", "delivery-address-management");
            }
          });
          return;
        }
        yield Ve();
      });
    }
    function Ve() {
      return k(this, null, function* () {
        const a = {
          isDryWarehouse: String(r.value.isDryWarehouse),
          baseCode: r.value.baseCode,
          base: r.value.base,
          receiverInfoList: r.value.shopList.reduce((e, { brandCategoryList: s, id: t }) => e.concat(s.map(({ brand: u, category: z }) => ({ receiverId: t, brand: u, category: z }))), [])
        };
        h.value = !0;
        try {
          const e = yield ya(a);
          e && (m.success("提交申请成功"), w.value = !1, ne(""), ue(), window.open(e, "_blank"), c == null || c(!0));
        } catch (e) {
          console.error("提交承运商申请失败:", e);
        } finally {
          h.value = !1;
        }
      });
    }
    function fe() {
      w.value = !1, ne(""), ue(), c == null || c(!1);
    }
    function Je() {
      return k(this, null, function* () {
        var s;
        if (!((s = x.value) != null && s.orgMarketManageRightId)) {
          m.warning("请选择K3扣费账户");
          return;
        }
        const a = x.value, e = yield ga({
          orgK3Name: a.orgK3Name,
          orgK3Code: a.orgK3Code,
          orgBelongClassifySalesName: a.orgBelongClassifySalesId,
          orgBelongClassifyId: a.orgBelongClassifyId,
          orgBelongClassifyName: a.orgBelongClassifyName
        });
        e && (window.open(e, "_blank"), w.value = !1, K(), c == null || c(!0));
      });
    }
    const de = d([]), A = d(null), ce = d([]), ye = d(0), i = d({
      customerName: "",
      customerTel: "",
      serviceId: "",
      serviceNo: "",
      orgId: "",
      pageSize: 20,
      pageNo: 1,
      isRelationOrder: 0,
      isTable: 0,
      orderId: ""
    }), Ge = [
      { type: "selection", width: 40, fixed: "left" },
      { title: "服务号", key: "serviceNo" },
      { title: "客户姓名", key: "customerName" },
      { title: "客户电话", key: "customerTel" },
      { title: "客户行政区划", key: "customerRegionText" },
      { title: "详细地址", key: "customerAddress" },
      { title: "导购", key: "salesman" },
      { title: "所属门店", key: "shopName" },
      { title: "创建人", key: "creator" },
      {
        title: "创建时间",
        key: "createDt",
        render(a) {
          return ca(a.createDt).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    ];
    function Fe(a) {
      ce.value = a.length ? [a[a.length - 1]] : [];
      const e = a[a.length - 1];
      A.value = e && de.value.find((s) => s.serviceNo === e) || null;
    }
    function Ye(a) {
      i.value.pageSize = a, q(1);
    }
    function q(a) {
      return k(this, null, function* () {
        var s, t, u, z;
        if (i.value.pageNo = a, !((s = B.value) != null && s.orgId) && !i.value.customerTel && !i.value.customerName && !i.value.serviceNo) {
          if (((t = B.value) == null ? void 0 : t.marketId) === "1")
            return;
          m.warning("请输入查询条件");
          return;
        }
        ((u = B.value) == null ? void 0 : u.marketId) !== "1" && (i.value.orgId = ((z = B.value) == null ? void 0 : z.orgId) || "");
        const e = {
          customerName: i.value.customerName,
          customerTel: i.value.customerTel,
          serviceId: i.value.serviceId,
          serviceNo: i.value.serviceNo,
          orgId: i.value.orgId,
          pageNo: String(i.value.pageNo),
          pageSize: String(i.value.pageSize)
        };
        try {
          const L = yield Ca(e);
          L && L.records && (de.value = L.records || [], ye.value = L.total || 0);
        } catch (L) {
          console.error("查询服务号失败:", L);
        }
      });
    }
    const X = d(null);
    function Ee() {
      return k(this, null, function* () {
        var a;
        if (!A.value) {
          m.warning("请选择服务号");
          return;
        }
        if (X.value === null && i.value.orderId) {
          m.warning("请先选择是否miform客户");
          return;
        }
        h.value = !0;
        try {
          const e = yield wa({
            serviceId: A.value.serviceId,
            serviceNo: A.value.serviceNo,
            customerName: A.value.customerName,
            isMiformCustomer: (a = X.value) != null ? a : void 0,
            isTable: i.value.isTable || 0,
            isRelationOrder: i.value.isRelationOrder || 0,
            orderId: i.value.orderId || ""
          });
          (e == null ? void 0 : e.status) === !0 ? (m.success("操作成功！"), w.value = !1, K(), c == null || c(!0), window.open(e == null ? void 0 : e.data, "_blank")) : m.error((e == null ? void 0 : e.message) || "操作失败！");
        } catch (e) {
          console.error("发起大家居特殊工艺失败:", e);
        } finally {
          h.value = !1;
        }
      });
    }
    function He() {
      return k(this, null, function* () {
        var e;
        if (!((e = x.value) != null && e.orgMarketManageRightId)) {
          m.warning("请选择审核人");
          return;
        }
        const a = yield fa({
          orgMarketRank: x.value.orgMarketRank,
          orgMarketRankName: x.value.orgMarketRankName,
          orgStoreAdminAccount: x.value.orgStoreAdminAccount,
          orgStoreAdminId: x.value.orgStoreAdminId,
          orgStoreAdminName: x.value.orgStoreAdminName
        });
        a && (window.open(a, "_blank"), w.value = !1, K(), c == null || c(!0));
      });
    }
    const G = d("retail"), j = d([]), D = d([]), F = d([]), b = d({ pageNo: 1, pageSize: 20, total: 0 }), P = d({
      searchKeywordByBaseSelfPickup: "",
      searchProductionOrderContractNo: "",
      pageNo: 1,
      pageSize: 20,
      orderCategory: "LSD",
      syncStatus: 1,
      orderDescs: [{ col: "createDt", desc: !0 }, { col: "no", desc: !0 }],
      applyCode: ""
    }), ee = d({
      applyNo: "",
      searchProductionOrderContractNo: "",
      pageNo: 1,
      pageSize: 20
    }), Qe = [
      { type: "selection", width: 55 },
      { title: "合同自编号", key: "productionOrderContractNo", minWidth: 180 },
      { title: "订单类别", key: "orderTypeName", minWidth: 80 },
      { title: "订单状态", key: "statusName", minWidth: 100 },
      { title: "产品渠道", key: "productChannelName", minWidth: 100 },
      { title: "客户姓名", key: "customerName", minWidth: 100 },
      { title: "客户电话", key: "customerTel", minWidth: 100 },
      { title: "订单编号", key: "no", minWidth: 150 },
      { title: "品牌", key: "brandName", minWidth: 80 },
      { title: "品类", key: "categoryName", minWidth: 100 }
    ];
    function we(a) {
      return a.id || a.orderId || a.contractNo;
    }
    function Ze(a) {
      F.value = a, D.value = a.map((e) => j.value.find((s) => we(s) === e)).filter(Boolean);
    }
    function qe() {
      D.value = [], F.value = [], j.value = [], b.value = { pageNo: 1, pageSize: 20, total: 0 };
    }
    function Xe(a) {
      b.value.pageSize = a, b.value.pageNo = 1, ae(1);
    }
    function ae(a) {
      return k(this, null, function* () {
        b.value.pageNo = a, h.value = !0;
        try {
          const e = G.value === "retail" ? le(te({}, P.value), { pageNo: a, pageSize: b.value.pageSize }) : le(te({}, P.value), {
            orderCategory: "GCD",
            searchKeywordByBaseSelfPickup: "",
            pageNo: a,
            pageSize: b.value.pageSize
          }), s = yield ha(e);
          s && s.records ? (j.value = s.records || [], b.value.total = s.total || 0) : (j.value = [], b.value.total = 0);
        } catch (e) {
          console.error("搜索失败:", e);
        } finally {
          h.value = !1;
        }
      });
    }
    function ea() {
      w.value = !1, j.value = [], D.value = [], F.value = [], c == null || c(!1);
    }
    function aa() {
      return k(this, null, function* () {
        if (!D.value.length) {
          m.warning("请勾选数据");
          return;
        }
        h.value = !0;
        try {
          const a = D.value.map((s) => s.no), e = yield ba({
            orderCategory: G.value === "retail" ? "LSD" : "GCD",
            orderNoList: a
          });
          e && (m.success("发起成功"), w.value = !1, window.open(e, "_blank"), c == null || c(!0));
        } catch (a) {
          console.error("发起申请失败:", a);
        } finally {
          h.value = !1;
        }
      });
    }
    function be(a) {
      switch (S.value.code = a, x.value = null, $.value = [], G.value = "retail", j.value = [], D.value = [], F.value = [], b.value = { pageNo: 1, pageSize: 20, total: 0 }, a) {
        case "bpm_process_dsdy_judge":
        case "bpm_process_relocatebase_judge":
          Ue();
          break;
        case "bpm_process_djjspecial_judge":
          q(1);
          break;
      }
    }
    function K() {
      w.value = !1, A.value = null, ce.value = [], i.value = {
        customerName: "",
        customerTel: "",
        serviceId: "",
        serviceNo: "",
        orgId: "",
        pageSize: 20,
        pageNo: 1,
        isRelationOrder: 0,
        isTable: 0,
        orderId: ""
      }, c == null || c(!1);
    }
    function ta(a) {
      return k(this, null, function* () {
        h.value = !0, w.value = !0, i.value = {
          customerName: "",
          customerTel: "",
          serviceId: "",
          serviceNo: "",
          orgId: "",
          pageSize: 20,
          pageNo: 1,
          isRelationOrder: 0,
          isTable: 0,
          orderId: ""
        }, a.serviceId && (i.value.serviceId = a.serviceId), a.serviceNo && (i.value.serviceNo = a.serviceNo), a.code && (S.value.code = a.code), a.disabledOptions !== void 0 && (ve.value = a.disabledOptions), a.disabledSearch !== void 0 && (W.value = a.disabledSearch), a.isRelationOrder && (i.value.isRelationOrder = a.isRelationOrder), a.isTable && (i.value.isTable = a.isTable), a.orderId && (i.value.orderId = a.orderId);
        const e = yield Ce();
        B.value = e;
        const s = da("MTDS");
        s.value.length === 0 && (yield new Promise((u) => {
          const z = setTimeout(u, 5e3), L = xa(s, (la) => {
            la.length > 0 && (clearTimeout(z), L(), u());
          });
        }));
        const t = yield Ne("ROOT_MTDS_bpm_special_process_application");
        return me.value = (t || []).filter((u) => (u.value || u.code) !== "all").map((u) => ({ label: u.label, code: u.value || u.code })), S.value.code && be(S.value.code), h.value = !1, Ke(), new Promise((u) => {
          c = u;
        });
      });
    }
    return y({ open: ta }), (a, e) => (C(), T(O, null, [
      p("div", {
        ref_key: "triggerContainer",
        ref: I
      }, null, 512),
      o(l(La), {
        show: w.value,
        "onUpdate:show": e[24] || (e[24] = (s) => w.value = s),
        to: I.value || "body"
      }, {
        default: n(() => [
          o(l(Ba), { show: h.value }, {
            default: n(() => [
              o(l(Ta), {
                style: { width: "1000px", "max-width": "80vw" },
                title: "发起申请",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: fe
              }, {
                default: n(() => {
                  var s;
                  return [
                    p("div", Ma, [
                      o(l(R), {
                        label: "申请类型：",
                        "label-width": 100,
                        size: "small"
                      }, {
                        default: n(() => [
                          o(l(Re), {
                            value: S.value.code,
                            "onUpdate:value": [
                              e[0] || (e[0] = (t) => S.value.code = t),
                              be
                            ],
                            options: Te.value,
                            placeholder: "请选择",
                            disabled: ve.value,
                            style: { width: "200px" }
                          }, null, 8, ["value", "options", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    S.value.code === "bpm_process_carrier" ? (C(), T(O, { key: 0 }, [
                      e[31] || (e[31] = p("div", { class: "tw:text-red-400 tw:ml-4 tw:mb-2" }, " 温馨提示：选择基地后，点击【查询】才能进行下一步选择收货地址 ", -1)),
                      p("div", ja, [
                        o(l(R), {
                          label: "基地",
                          "label-width": 100,
                          size: "small"
                        }, {
                          default: n(() => [
                            o(l(Re), {
                              value: r.value.baseCode,
                              options: se.value,
                              placeholder: "请选择基地",
                              "onUpdate:value": ne,
                              style: { width: "200px" }
                            }, null, 8, ["value", "options"])
                          ]),
                          _: 1
                        }),
                        V.value ? _("", !0) : (C(), oe(l(f), {
                          key: 0,
                          type: "primary",
                          size: "small",
                          onClick: e[1] || (e[1] = (t) => Z(1, !0))
                        }, {
                          default: n(() => e[25] || (e[25] = [
                            v("查询", -1)
                          ])),
                          _: 1,
                          __: [25]
                        })),
                        V.value ? _("", !0) : (C(), oe(l(f), {
                          key: 1,
                          type: "primary",
                          size: "small",
                          onClick: e[2] || (e[2] = (t) => V.value = !0)
                        }, {
                          default: n(() => e[26] || (e[26] = [
                            v("更多筛选", -1)
                          ])),
                          _: 1,
                          __: [26]
                        }))
                      ]),
                      V.value ? (C(), T("div", Da, [
                        o(l(R), {
                          label: "收货地址",
                          "label-width": 100,
                          size: "small",
                          class: "tw:flex-1"
                        }, {
                          default: n(() => [
                            p("div", Ua, [
                              o(pa, {
                                modelValue: r.value.region,
                                "onUpdate:modelValue": e[3] || (e[3] = (t) => r.value.region = t),
                                isDirectly: !0,
                                class: "tw:flex-1"
                              }, null, 8, ["modelValue"]),
                              o(l(M), {
                                value: r.value.address,
                                "onUpdate:value": e[4] || (e[4] = (t) => r.value.address = t),
                                clearable: ""
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _: 1
                        }),
                        o(l(f), {
                          type: "primary",
                          size: "small",
                          onClick: e[5] || (e[5] = (t) => Z(1, !0))
                        }, {
                          default: n(() => e[27] || (e[27] = [
                            v("查询", -1)
                          ])),
                          _: 1,
                          __: [27]
                        }),
                        o(l(f), {
                          type: "primary",
                          size: "small",
                          onClick: ue
                        }, {
                          default: n(() => e[28] || (e[28] = [
                            v("收起", -1)
                          ])),
                          _: 1,
                          __: [28]
                        })
                      ])) : _("", !0),
                      p("div", Aa, [
                        o(l(Y), {
                          columns: Ae,
                          data: J.value,
                          bordered: !0,
                          "max-height": 323,
                          "row-key": (t) => t.keyId,
                          "checked-row-keys": ie.value,
                          "onUpdate:checkedRowKeys": Oe
                        }, null, 8, ["data", "row-key", "checked-row-keys"]),
                        p("div", Pa, [
                          p("span", Ka, "共 " + Se(r.value.total) + " 条", 1),
                          o(l(pe), {
                            page: r.value.pageNo,
                            "onUpdate:page": [
                              e[6] || (e[6] = (t) => r.value.pageNo = t),
                              Z
                            ],
                            "page-size": r.value.pageSize,
                            "onUpdate:pageSize": [
                              e[7] || (e[7] = (t) => r.value.pageSize = t),
                              We
                            ],
                            "item-count": r.value.total,
                            "page-sizes": [10, 20, 50, 100],
                            "show-size-picker": ""
                          }, null, 8, ["page", "page-size", "item-count"])
                        ])
                      ]),
                      r.value.baseCode ? (C(), T("div", Oa, [
                        o(l(f), { onClick: fe }, {
                          default: n(() => e[29] || (e[29] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [29]
                        }),
                        o(l(f), {
                          type: "primary",
                          onClick: $e
                        }, {
                          default: n(() => e[30] || (e[30] = [
                            v("确定", -1)
                          ])),
                          _: 1,
                          __: [30]
                        })
                      ])) : _("", !0)
                    ], 64)) : _("", !0),
                    S.value.code === "bpm_process_dsdy_judge" ? (C(), T(O, { key: 1 }, [
                      e[34] || (e[34] = p("h3", { class: "tw:text-base tw:mb-2" }, "选择k3扣费账户", -1)),
                      o(l(Y), {
                        columns: je,
                        data: H.value,
                        bordered: !0,
                        "max-height": 250,
                        "row-key": (t) => t.orgMarketManageRightId,
                        "checked-row-keys": $.value,
                        "onUpdate:checkedRowKeys": ge
                      }, null, 8, ["data", "row-key", "checked-row-keys"]),
                      p("div", Wa, [
                        o(l(f), { onClick: K }, {
                          default: n(() => e[32] || (e[32] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [32]
                        }),
                        o(l(f), {
                          type: "primary",
                          onClick: Je
                        }, {
                          default: n(() => e[33] || (e[33] = [
                            v("发起", -1)
                          ])),
                          _: 1,
                          __: [33]
                        })
                      ])
                    ], 64)) : _("", !0),
                    S.value.code === "bpm_process_djjspecial_judge" ? (C(), T(O, { key: 2 }, [
                      p("div", $a, [
                        ((s = B.value) == null ? void 0 : s.marketId) !== "1" ? (C(), oe(l(R), {
                          key: 0,
                          label: "客户姓名",
                          size: "small",
                          "label-width": 80
                        }, {
                          default: n(() => [
                            o(l(M), {
                              value: i.value.customerName,
                              "onUpdate:value": e[8] || (e[8] = (t) => i.value.customerName = t),
                              disabled: W.value,
                              clearable: ""
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })) : _("", !0),
                        o(l(R), {
                          label: "客户电话",
                          size: "small",
                          "label-width": 80
                        }, {
                          default: n(() => [
                            o(l(M), {
                              value: i.value.customerTel,
                              "onUpdate:value": e[9] || (e[9] = (t) => i.value.customerTel = t),
                              disabled: W.value,
                              clearable: ""
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        o(l(R), {
                          label: "服务号",
                          size: "small",
                          "label-width": 80
                        }, {
                          default: n(() => [
                            o(l(M), {
                              value: i.value.serviceNo,
                              "onUpdate:value": e[10] || (e[10] = (t) => i.value.serviceNo = t),
                              disabled: W.value,
                              clearable: ""
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        o(l(f), {
                          type: "primary",
                          size: "small",
                          disabled: W.value,
                          onClick: e[11] || (e[11] = (t) => q(1))
                        }, {
                          default: n(() => e[35] || (e[35] = [
                            v("搜索", -1)
                          ])),
                          _: 1,
                          __: [35]
                        }, 8, ["disabled"]),
                        i.value.orderId ? (C(), T("span", Va, e[36] || (e[36] = [
                          p("span", { style: { color: "#d03050" } }, "*", -1),
                          v("是否miform客户：", -1)
                        ]))) : _("", !0),
                        i.value.orderId ? (C(), oe(l(Sa), {
                          key: 2,
                          value: X.value,
                          "onUpdate:value": e[12] || (e[12] = (t) => X.value = t),
                          label: "是否miform客户"
                        }, {
                          default: n(() => [
                            o(l(_e), { value: 0 }, {
                              default: n(() => e[37] || (e[37] = [
                                v("否", -1)
                              ])),
                              _: 1,
                              __: [37]
                            }),
                            o(l(_e), { value: 1 }, {
                              default: n(() => e[38] || (e[38] = [
                                v("是", -1)
                              ])),
                              _: 1,
                              __: [38]
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])) : _("", !0)
                      ]),
                      e[41] || (e[41] = p("div", { class: "tw:mb-2 tw:font-bold" }, [
                        v(" 请在"),
                        p("span", { class: "tw:text-rose-700 tw:mx-1" }, "下单前"),
                        v("发起审批单，审批结束后务必 "),
                        p("span", { class: "tw:text-rose-700 tw:mx-1" }, "在一键下单关联或传单前绑定审批单"),
                        v("，无非标不关联不绑定！ ")
                      ], -1)),
                      o(l(Y), {
                        columns: Ge,
                        data: de.value,
                        bordered: !0,
                        "max-height": 400,
                        "row-key": (t) => t.serviceNo,
                        "checked-row-keys": ce.value,
                        "onUpdate:checkedRowKeys": Fe
                      }, null, 8, ["data", "row-key", "checked-row-keys"]),
                      p("div", Ja, [
                        o(l(pe), {
                          page: i.value.pageNo,
                          "onUpdate:page": [
                            e[13] || (e[13] = (t) => i.value.pageNo = t),
                            q
                          ],
                          "page-size": i.value.pageSize,
                          "onUpdate:pageSize": [
                            e[14] || (e[14] = (t) => i.value.pageSize = t),
                            Ye
                          ],
                          "item-count": ye.value,
                          "show-size-picker": "",
                          "page-sizes": [10, 20, 50]
                        }, null, 8, ["page", "page-size", "item-count"])
                      ]),
                      p("div", Ga, [
                        o(l(f), { onClick: K }, {
                          default: n(() => e[39] || (e[39] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [39]
                        }),
                        o(l(f), {
                          type: "primary",
                          onClick: Ee
                        }, {
                          default: n(() => e[40] || (e[40] = [
                            v("发起", -1)
                          ])),
                          _: 1,
                          __: [40]
                        })
                      ])
                    ], 64)) : _("", !0),
                    S.value.code === "bpm_process_relocatebase_judge" ? (C(), T(O, { key: 3 }, [
                      e[44] || (e[44] = p("h4", { class: "tw:text-base tw:mb-2" }, "选择审核人信息", -1)),
                      o(l(Y), {
                        columns: De,
                        data: H.value,
                        bordered: !0,
                        "max-height": 250,
                        "row-key": (t) => t.orgMarketManageRightId,
                        "checked-row-keys": $.value,
                        "onUpdate:checkedRowKeys": ge
                      }, null, 8, ["data", "row-key", "checked-row-keys"]),
                      p("div", Fa, [
                        o(l(f), { onClick: K }, {
                          default: n(() => e[42] || (e[42] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [42]
                        }),
                        o(l(f), {
                          type: "primary",
                          onClick: He
                        }, {
                          default: n(() => e[43] || (e[43] = [
                            v("发起", -1)
                          ])),
                          _: 1,
                          __: [43]
                        })
                      ])
                    ], 64)) : _("", !0),
                    S.value.code === "bpm_process_baseselfpickup_judge" ? (C(), T(O, { key: 4 }, [
                      o(l(_a), {
                        value: G.value,
                        "onUpdate:value": [
                          e[21] || (e[21] = (t) => G.value = t),
                          qe
                        ],
                        type: "line"
                      }, {
                        default: n(() => [
                          o(l(ze), {
                            name: "retail",
                            tab: "零售单"
                          }, {
                            default: n(() => [
                              p("div", Ya, [
                                o(l(R), {
                                  label: "搜索",
                                  size: "small",
                                  "label-width": 80
                                }, {
                                  default: n(() => [
                                    o(l(M), {
                                      value: P.value.searchKeywordByBaseSelfPickup,
                                      "onUpdate:value": e[15] || (e[15] = (t) => P.value.searchKeywordByBaseSelfPickup = t),
                                      placeholder: "客户姓名/电话/主合同号",
                                      clearable: "",
                                      style: { width: "200px" }
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                o(l(R), {
                                  label: "合同自编号",
                                  size: "small",
                                  "label-width": 80
                                }, {
                                  default: n(() => [
                                    o(l(M), {
                                      value: P.value.searchProductionOrderContractNo,
                                      "onUpdate:value": e[16] || (e[16] = (t) => P.value.searchProductionOrderContractNo = t),
                                      placeholder: "合同自编号(批量用中英文逗号或空格隔开)",
                                      clearable: "",
                                      style: { width: "280px" }
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                o(l(f), {
                                  type: "primary",
                                  size: "small",
                                  onClick: e[17] || (e[17] = (t) => ae(1))
                                }, {
                                  default: n(() => e[45] || (e[45] = [
                                    v("搜索", -1)
                                  ])),
                                  _: 1,
                                  __: [45]
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          o(l(ze), {
                            name: "project",
                            tab: "工程单"
                          }, {
                            default: n(() => [
                              p("div", Ea, [
                                o(l(R), {
                                  label: "下单申请号",
                                  size: "small",
                                  "label-width": 80
                                }, {
                                  default: n(() => [
                                    o(l(M), {
                                      value: ee.value.applyNo,
                                      "onUpdate:value": e[18] || (e[18] = (t) => ee.value.applyNo = t),
                                      placeholder: "下单申请号",
                                      clearable: "",
                                      style: { width: "200px" }
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                o(l(R), {
                                  label: "合同自编号",
                                  size: "small",
                                  "label-width": 80
                                }, {
                                  default: n(() => [
                                    o(l(M), {
                                      value: ee.value.searchProductionOrderContractNo,
                                      "onUpdate:value": e[19] || (e[19] = (t) => ee.value.searchProductionOrderContractNo = t),
                                      placeholder: "合同自编号(批量用中英文逗号或空格隔开)",
                                      clearable: "",
                                      style: { width: "280px" }
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                o(l(f), {
                                  type: "primary",
                                  size: "small",
                                  onClick: e[20] || (e[20] = (t) => ae(1))
                                }, {
                                  default: n(() => e[46] || (e[46] = [
                                    v("搜索", -1)
                                  ])),
                                  _: 1,
                                  __: [46]
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      p("div", Ha, [
                        p("span", null, "已选择 " + Se(D.value.length) + " 项", 1)
                      ]),
                      o(l(Y), {
                        columns: Qe,
                        data: j.value,
                        bordered: !0,
                        "max-height": 350,
                        "row-key": we,
                        "checked-row-keys": F.value,
                        "onUpdate:checkedRowKeys": Ze
                      }, null, 8, ["data", "checked-row-keys"]),
                      p("div", Qa, [
                        o(l(pe), {
                          page: b.value.pageNo,
                          "onUpdate:page": [
                            e[22] || (e[22] = (t) => b.value.pageNo = t),
                            ae
                          ],
                          "page-size": b.value.pageSize,
                          "onUpdate:pageSize": [
                            e[23] || (e[23] = (t) => b.value.pageSize = t),
                            Xe
                          ],
                          "item-count": b.value.total,
                          "show-size-picker": "",
                          "page-sizes": [20, 50, 100]
                        }, null, 8, ["page", "page-size", "item-count"])
                      ]),
                      p("div", Za, [
                        o(l(f), { onClick: ea }, {
                          default: n(() => e[47] || (e[47] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [47]
                        }),
                        o(l(f), {
                          type: "primary",
                          onClick: aa
                        }, {
                          default: n(() => e[48] || (e[48] = [
                            v("发起", -1)
                          ])),
                          _: 1,
                          __: [48]
                        })
                      ])
                    ], 64)) : _("", !0)
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"]),
      o(va, {
        ref_key: "brandCategorySelectorRef",
        ref: U
      }, null, 512)
    ], 64));
  }
});
export {
  Lt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/mall-sp-approval-trigger/mallSpApprovalTrigger.ce.vue.js
// module id = 1263
// module chunks = 41